/* tslint:disable */

/**
 * HR Portal API
 * HR Portal API
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
    RequestComment,
    RequestCommentFromJSON,
    RequestCommentToJSON,
} from './';

/**
 *
 * @export
 * @interface RequestComments
 */
export interface RequestComments {
    /**
     *
     * @type {Array<RequestComment>}
     * @memberof RequestComments
     */
    comments: RequestComment[];
    /**
     *
     * @type {boolean}
     * @memberof RequestComments
     */
    isNextPage: boolean;
}

export function RequestCommentsFromJSON(json: any): RequestComments {
    return RequestCommentsFromJSONTyped(json, false);
}

export function RequestCommentsFromJSONTyped(json: any, _: boolean): RequestComments {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'comments': ((json['comments'] as any[]).map(RequestCommentFromJSON)),
        'isNextPage': json['is_next_page'],
    };
}

export function RequestCommentsToJSON(value?: RequestComments | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'comments': ((value.comments as any[]).map(RequestCommentToJSON)),
        'is_next_page': value.isNextPage,
    };
}
